// istanbul ignore next -- valeur d'environnement résolue au build, hors logique applicative testable
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';